export * from 'store/actions.js';

export const NETFLIX_BUTTON_CLICK = 'NETFLIX_BUTTON_CLICK';
export const NETFLIX_GALLERY_ITEM_CLICK = 'NETFLIX_GALLERY_ITEM_CLICK';
export const NETFLIX_GALLERY_ITEM_LINK_CLICK = 'NETFLIX_GALLERY_ITEM_LINK_CLICK';
export const NETFLIX_RESOURCE_CLICK = 'NETFLIX_RESOURCE_CLICK';
